export interface ICommentShared {
	commentId: string;
	dateCreated: Date;
	sender: {
		name: string;
		username: string;
	};
	content: {
		type: IssueCommentType;
		value: string;
		sizeInBytes?: number | null;
		filename?: string | null;
	};
}

export enum IssueCommentType {
	IMAGE = 'image',
	TEXT = 'text',
	PDF = 'pdf',
}
